import React from "react";
import {
  AHTeamIconCircle,
  AHTeamIconType,
  AHWidgetTitleText,
  Box,
  Overlap,
  useCircleSize,
  useLayoutContext,
} from "arkh";
import { formatTeamNames, TeamNamesLabel } from "./DialogButtonTeams";
import { useIntl } from "react-intl";

type WidgetTeam = {
  readonly name: string;
  readonly icon: AHTeamIconType;
  readonly color: string | null;
};

type WidgetHeaderOptionsProps = {
  teams: readonly WidgetTeam[];
  roles?: readonly { readonly name: string }[];
  withoutRoleSelected?: boolean;
};

const MAX_NAMED_TEAMS = 2;
const MAX_ICONS = 5;

function WidgetHeaderOptionsC(props: WidgetHeaderOptionsProps) {
  const layout = useLayoutContext();
  const circleSize = useCircleSize("small");
  const intl = useIntl();

  const names = props.teams.slice(0, MAX_NAMED_TEAMS).map((t) => t.name);
  const extraCount = Math.max(props.teams.length - MAX_NAMED_TEAMS, 0);
  const iconTeams = props.teams.slice(0, MAX_ICONS);

  const roleNames = [
    ...(props.withoutRoleSelected
      ? [
          intl.formatMessage({
            defaultMessage: "Without role",
            description: "intl_token Without role",
          }),
        ]
      : []),
    ...(props.roles?.map((r) => r.name) ?? []),
  ];
  const roleLabel =
    roleNames.length > 0 ? formatTeamNames(roleNames, MAX_NAMED_TEAMS) : null;

  return (
    <Box
      style={{
        flexDirection: "row",
        alignItems: "center",
        flexShrink: 1,
        minWidth: 0,
      }}
    >
      {roleLabel != null && (
        <AHWidgetTitleText color="text-secondary">
          {roleLabel}
        </AHWidgetTitleText>
      )}
      <AHWidgetTitleText
        color="text-secondary"
        style={{
          textAlign: "right",
          paddingRight: layout.space.xsmall,
        }}
      >
        <TeamNamesLabel names={names} />
        {extraCount > 0 ? ` +${extraCount}` : ""}
      </AHWidgetTitleText>
      {props.teams.length === 0 ? (
        <AHTeamIconCircle type="default" color={null} size="small" />
      ) : (
        <Overlap
          data={iconTeams}
          viewWidth={circleSize}
          direction="end"
          render={(t) => (
            <AHTeamIconCircle type={t.icon} color={t.color} size="small" />
          )}
        />
      )}
    </Box>
  );
}

export const WidgetHeaderOptions = React.memo(WidgetHeaderOptionsC);
